import { i18nTranslationHelper } from '@/i18n'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import { AppBar, Dialog, IconButton, List, Toolbar } from '@mui/material'
import SearchAutocomplete from '../../../input/global-search-field/search-autocomplete'
import SearchTypeDecisor from '../../../input/global-search-field/search-type-decisor'
import {
  MIN_AUTOCOMPLETE_SEARCH_LENGTH,
  useGlobalSearch
} from '../../../input/global-search-field/use-global-search'
import SearchField from '../../../input/search-field'
import DialogMenuTransition from '../../../transition/dialog-menu-transition'
import SxHeader from '../../sx-header'

export type MobileNavMenuProps = {
  open: boolean
  handleClose: () => void
}

export default function MobileSearchMenu({ open, handleClose }: MobileNavMenuProps) {
  const t = i18nTranslationHelper.getTComponents
  const {
    search,
    searchType,
    loadingAutocomplete,
    matchedWords,
    handleSearch,
    handleAutoCompleteSelect,
    handleSearchTypeChange,
    handleSearchTypeUpdate,
    handleSearchInputFocus,
    handleClearInput,
    autoComplete
  } = useGlobalSearch()

  const searchFieldElement = document.getElementById('menu-search-field')
  searchFieldElement?.focus()

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      sx={{ display: { xs: 'inherit', md: 'none' } }}
      disableScrollLock
      slots={{
        transition: DialogMenuTransition
      }}
    >
      <AppBar component="header" sx={SxHeader.appBarNoShadow}>
        <Toolbar
          sx={{
            height: theme => theme.spacing(6),
            mt: theme => theme.spacing(1)
          }}
        >
          <SearchField
            id="menu-search-field"
            placeholder={t('bannerSearch.placeholder')}
            onSearch={value => {
              handleSearch(value, searchType)
              handleClose()
            }}
            onFieldChange={autoComplete}
            onClearInput={handleClearInput}
            onFocusChange={handleSearchInputFocus}
            value={search}
          />

          <IconButton
            size="small"
            aria-controls={open ? 'close-links-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClose}
          >
            <CloseOutlinedIcon />
          </IconButton>
        </Toolbar>

        <List dense sx={{ px: theme => theme.spacing(2) }}>
          <SearchTypeDecisor
            onSearchTypeChange={option => {
              handleSearchTypeChange(option)
              handleClose()
            }}
            onSearchTypeUpdate={handleSearchTypeUpdate}
          />
          {search.length >= MIN_AUTOCOMPLETE_SEARCH_LENGTH && (
            <SearchAutocomplete
              loading={loadingAutocomplete}
              matchedWords={matchedWords}
              onSelect={term => {
                handleAutoCompleteSelect(term)
                handleClose()
              }}
              searchTerm={search}
            />
          )}
        </List>
      </AppBar>
    </Dialog>
  )
}
